import styled from "styled-components"
import { device } from "breakpoints"
import { getSolidColor } from "helpers/getSolidColor"
export const TagFootNoteContainer = styled.div`
  width: 100%;

  @media ${device.desktop} {
    margin-top: 30px;
    padding-right: 55px;
  }
`

export const Tags = styled.ul`
  list-style: none;
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px solid #d2d4e0;
  padding-bottom: 13px;
  margin-bottom: 21px;
  flex-wrap: wrap;

  @media ${device.tablet} {
    padding-bottom: 31px;
  }
`

export const Tag = styled.li`
  font-weight: 600;
  font-size: 12px;
  color: #ffffff;
  letter-spacing: -0.09px;
  text-align: center;
  line-height: 14px;
  text-transform: uppercase;
  background: ${props => getSolidColor(props.theme.site)};
  border-radius: 2px;
  padding: 5px 8px;
  margin-right: 9px;
  margin-bottom: 10px;

  :last-child {
    margin-right: 0;
  }

  @media ${device.tablet} {
    font-size: 14px;
    letter-spacing: -0.11px;
    text-align: center;
    line-height: 14px;

    padding: 6px 10px;
  }
`

export const Footnote = styled.p`
  font-weight: 400;
  font-size: 12px;
  color: #4c4d58;
  letter-spacing: -0.09px;
  line-height: 18px;

  @media ${device.tablet} {
    font-size: 16px;
    letter-spacing: -0.12px;
    line-height: 30px;
  }
`
